import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Host, Input, Optional, Self, SkipSelf } from '@angular/core';
import { ControlContainer, FormBuilder, NgControl } from '@angular/forms';
import { PagedSelectComponent } from '@components/paged-select/paged-select.component';
import { ComputersFacade } from 'mbs-ui-shared@facades/computers.facade';
import Computer from 'mbs-ui-shared@models/Computer';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mbs-computer-select',
  templateUrl: './paged-select.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComputerSelectComponent extends PagedSelectComponent<Computer> {
  @Input() placeholder = this.i18nPipe.transform('shared:captions.computers');
  @Input() counterLabel = this.i18nPipe.transform('shared:captions.computers');

  protected bindLabel = 'name';
  protected bindValue = 'hid';

  constructor(
    @Optional() @Host() @SkipSelf() public controlContainer: ControlContainer,
    @Optional() @Self() protected ngControl: NgControl,
    private facade: ComputersFacade,
    protected fb: FormBuilder,
    protected cdr: ChangeDetectorRef,
    private i18nPipe: I18NextPipe
  ) {
    super(controlContainer, ngControl, fb, cdr);
  }

  protected loadData(): void {
    this.facade.loadData(false, true);
  }

  protected get getData$(): Observable<Computer[]> {
    return this.facade.getData$();
  }

  protected loadById(id: string): void {
    this.facade.loadComputerByHid({ hid: id });
  }

  protected getById$(id: string): Observable<Computer> {
    return this.facade.getByHid(id);
  }

  protected get getTotal$(): Observable<number> {
    return this.facade.getDataTotal$;
  }

  protected get allLoaded$(): Observable<boolean> {
    return this.facade.getAllDataLoaded$;
  }

  protected get dataHasError$(): Observable<boolean> {
    return this.facade.getDataHasError$;
  }

  protected get loadingData$(): Observable<boolean> {
    return this.facade.getDataLoading$;
  }

  protected get loadingById$(): Observable<boolean> {
    return this.facade.computerLoading$;
  }

  protected areItemsTheSame(selectedItem: Computer, item: Computer): boolean {
    return selectedItem.hid === item.hid;
  }
}
